import { SelfMapObjectKeys } from '@cm/utility/types';
import { LocMap } from './loc-map.type';
import { LocDefs } from './localization';
export const MapLocKeys = <T extends string>(locs: LocDefs<T>): LocMap<T> => SelfMapObjectKeys(locs) as LocMap<T>;
